import React from "react";

function UserIcon() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3080_1512)">
        <path
          d="M15.9946 15.4955C15.9946 14.0443 14.6034 12.8106 12.6624 12.3524M10.9964 15.4955C10.9964 13.6545 8.75885 12.1633 5.99819 12.1633C3.23752 12.1633 1 13.6545 1 15.4955M10.9964 9.66425C11.8801 9.66425 12.7276 9.31319 13.3525 8.68829C13.9774 8.0634 14.3285 7.21586 14.3285 6.33212C14.3285 5.44839 13.9774 4.60085 13.3525 3.97596C12.7276 3.35106 11.8801 3 10.9964 3M5.99819 9.66425C5.11445 9.66425 4.26691 9.31319 3.64202 8.68829C3.01712 8.0634 2.66606 7.21586 2.66606 6.33212C2.66606 5.44839 3.01712 4.60085 3.64202 3.97596C4.26691 3.35106 5.11445 3 5.99819 3C6.88192 3 7.72946 3.35106 8.35435 3.97596C8.97925 4.60085 9.33031 5.44839 9.33031 6.33212C9.33031 7.21586 8.97925 8.0634 8.35435 8.68829C7.72946 9.31319 6.88192 9.66425 5.99819 9.66425Z"
          stroke="#667085"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3080_1512">
          <rect width="18" height="18" fill="white" transform="translate(-1)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UserIcon;
